import React, { useState } from 'react'

import Box from './Box'
import Button from './Button'
import Input from './Input'

const ContactForm = () => {
  const [state, setState] = useState({
    firstname: '',
    lastname: '',
    email: '',
    phone: '',
    message: '',
  })

  function onSubmit(e) {
    e.preventDefault()
    console.log(state)
  }

  function onChange(e) {
    const { name, value } = e.target

    setState({ ...state, [name]: value })
  }

  const fields = [
    {
      name: 'firstname',
      label: 'Your firstname',
      props: { style: { width: '48%' } },
    },
    {
      name: 'lastname',
      label: 'Your lastname',
      props: { style: { width: '48%' } },
    },
    {
      name: 'email',
      label: 'Email address',
      props: { style: { width: '48%' } },
    },
    {
      name: 'phone',
      label: 'Phone',
      props: { style: { width: '48%' } },
    },
    {
      name: 'message',
      label: 'Your Message',
      props: { multiline: true, rows: 4 },
    },
  ]

  return (
    <Box
      as="form"
      onSubmit={onSubmit}
      display="flex"
      flexWrap="wrap"
      css={{ '& .MuiTextField-root': { margin: 8 } }}
    >
      {fields.map(field => (
        <Input
          key={field.name}
          name={field.name}
          label={field.label}
          value={state[field.name]}
          onChange={onChange}
          InputLabelProps={{ shrink: true }}
          {...field.props}
        />
      ))}
      <Button type="submit" color="primary" round>
        Absenden
      </Button>
    </Box>
  )
}

export default ContactForm
